export const GIVE_OUT = 'give_out';
